import { SortOrder } from "@/types/gql/graphql";
import { DecreeCategory } from "@/types/gql/graphql";
import { Extension } from "@/types/gql/graphql";
import { Point, Position } from "geojson";
import { Address } from "./address.type";
import { Restriction } from "./restriction.type";

export type Decree = {
  cityId: string;
  createdAt: Date;
  done: boolean;
  id: string;
  name: string;
  publicUrl?: string;
  title?: string;
  decreeNumber?: string | null;
  analyzed?: boolean;
  restrictions?: Restriction[];
  restrictionsCount?: number;
  category: DecreeCategory;
  publishedDate?: Date;
  comments?: string;
  type?: TemporaryDecreeType | PermitDecreeType | null;
  startDate?: Date;
  endDate?: Date;
  extension?: Extension | null;
};

export type TemporaryDecree = Decree & {
  type?: TemporaryDecreeType | null;
};

export type PermitDecreeLocation = {
  id: string;
  position: Point;
  address: Address;
};

export type PermitLocation = {
  id: string;
  position: Point;
  address: Address;
  selectedDecrees: {
    value: string;
    label: string;
  }[];
};

export type PermitLocationPoint = {
  id: string;
  coordinates: Position;
  address: Address;
  selectedDecrees: {
    value: string;
    label: string;
  }[];
};

export type PermitDecree = Decree & {
  type?: PermitDecreeType | null;
  locations?: PermitDecreeLocation[];
  startDate: Date;
  endDate: Date;
};

export type TemporaryDecreeRaw = Decree & {
  temporaryType?: TemporaryDecree["type"];
};
export type PermitDecreeRaw = PermitDecree & {
  permitType?: PermitDecree["type"];
};

export type CreateDecreeInput = {
  name: string;
  title?: string;
  attachedFile: File;
  cityId: string;
  done?: boolean;
  comments?: string;
  category: DecreeCategory;
  publishedDate: Date;
};

export type CreateTemporaryDecreeInput = CreateDecreeInput & {
  type: TemporaryDecreeType;
};

export type CreatePermitDecreeInput = CreateDecreeInput & {
  type: PermitDecreeType;
  startDate: Date;
  endDate: Date;
};

export type UpdateDecreeInput = {
  id: string;
  name?: string;
  done?: boolean;
  comments?: string;
  title?: string;
  decreeNumber?: string | null;
  publishedDate?: Date;
};

export type PaginatedDecrees = {
  results: Decree[];
  totalPages: number;
  totalCount: number;
};

export type PaginatedDecreeArgs = {
  cityId: string;
  pageIndex: number;
  pageSize: number;
  sortOrder?: SortOrder;
  sortField?: keyof Decree;
  filter: DecreeFilterList;
};

export type DecreeFilterList = {
  field: keyof Decree | "text";
  value: string;
}[];

export enum TemporaryDecreeType {
  moving = "Déménagement",
  constructionWork = "Travaux",
  oneTimeEvent = "Évenement ponctuel",
  other = "Autres",
}

export enum PermitDecreeType {
  building = "Construction",
  demolition = "Démolition",
  development = "Aménagement",
  priorDeclaration = "Déclaration préalable",
  singleFamilyHomeBuilding = "PC pour maison individuelle",
  buildingAndDemolition = "PC valant démolition",
  other = "Autres",
}
